/** Presentation identity only; this prefix never grants thread access. */
export const VOICE_CHAT_ROUTE_PREFIX = 'ot_voice-';

export function isVoiceChatRoute(routeId: string | null | undefined): boolean {
  return routeId?.startsWith(VOICE_CHAT_ROUTE_PREFIX) ?? false;
}
